import { FC, memo } from 'react';

import KpiDashboardPresenter from './KpiDashboard/Presenter';

const KpiDashboard: FC = memo(() => (
  <KpiDashboardPresenter />
));

export default KpiDashboard;
